"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var CardContainer_styled_exports = {};
__export(CardContainer_styled_exports, {
  CardContainerStyled: () => CardContainerStyled,
  ContentLayout: () => ContentLayout,
  IconContainerStyled: () => IconContainerStyled,
  IconStyled: () => IconStyled
});
module.exports = __toCommonJS(CardContainer_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_Icon = require("../../../atoms/Icon/Icon.component");
var borderVariant = {
  live: {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(112 108 92 / var(--tw-border-opacity))",
    "outlineStyle": "solid",
    "outlineWidth": "3px",
    "outlineOffset": "3px",
    "outlineColor": "#E4844F"
  },
  notification: {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(156 71 25 / var(--tw-border-opacity))"
  },
  "default": {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(112 108 92 / var(--tw-border-opacity))"
  }
};
var CardContainerStyled = import_styled_components.default.div.withConfig({
  displayName: "CardContainerstyled__CardContainerStyled",
  componentId: "sc-q11r2u-0"
})(function(_ref) {
  var backgroundColor = _ref.backgroundColor, _ref$cardState = _ref.cardState, cardState = _ref$cardState === void 0 ? "default" : _ref$cardState;
  return [{
    "display": "flex",
    "minHeight": "116px",
    "width": "100%",
    "minWidth": "200px",
    "borderRadius": "8.5px",
    "borderWidth": "1px",
    "borderStyle": "solid"
  }, backgroundColor === "white" ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
  } : {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(250 251 249 / var(--tw-bg-opacity))"
  }, borderVariant[cardState]];
});
var IconContainerStyled = import_styled_components.default.div.withConfig({
  displayName: "CardContainerstyled__IconContainerStyled",
  componentId: "sc-q11r2u-1"
})({
  "position": "relative"
});
var IconStyled = (0, import_styled_components.default)(import_Icon.Icon).withConfig({
  displayName: "CardContainerstyled__IconStyled",
  componentId: "sc-q11r2u-2"
})({
  "position": "absolute",
  "right": "-0.875rem",
  "top": "-0.875rem",
  "display": "flex",
  "height": "1.5rem",
  "width": "1.5rem",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "1.5rem",
  "borderWidth": "2px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(255 255 255 / var(--tw-border-opacity))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(156 71 25 / var(--tw-bg-opacity))"
});
var handleStyles = function handleStyles2(numberOfChildren, is400percent) {
  var is400percentStyles = is400percent ? [{
    "flexDirection": "column"
  }, {
    "> :first-child": {
      "flexDirection": "column"
    }
  }] : [{
    "flexDirection": "row"
  }, {
    "> :first-child": {
      "flexDirection": "row"
    }
  }];
  var numberOfChildMoreThanOneStyles = [{
    "> :first-child:hover,> :first-child:focus-within": {
      "boxSizing": "border-box",
      "borderRadius": "0"
    }
  }, is400percent ? {
    "> :first-child:hover,> :first-child:focus-within": {
      "borderTopLeftRadius": "0.5rem",
      "borderTopRightRadius": "0.5rem"
    }
  } : {
    "> :first-child:hover,> :first-child:focus-within": {
      "borderTopLeftRadius": "0.5rem",
      "borderBottomLeftRadius": "0.5rem"
    }
  }];
  return [is400percentStyles, numberOfChildren > 1 ? numberOfChildMoreThanOneStyles : {
    "> :first-child:hover,> :first-child:focus-within": {
      "boxSizing": "border-box",
      "borderRadius": "0.5rem"
    }
  }];
};
var ContentLayout = import_styled_components.default.div.withConfig({
  displayName: "CardContainerstyled__ContentLayout",
  componentId: "sc-q11r2u-3"
})(function(_ref2) {
  var is400percent = _ref2.is400percent, numberOfChildren = _ref2.numberOfChildren;
  return [{
    "display": "flex",
    "width": "100%",
    "justifyContent": "space-between",
    "color": "inherit"
  }, {
    "> :first-child": {
      "display": "flex",
      "width": "100%",
      "padding": "0px"
    }
  }, {
    "> a div": {
      "cursor": "pointer"
    }
  }, {
    "> :first-child:link": {
      "color": "inherit"
    }
  }, {
    "> a:hover": {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(242 244 237 / var(--tw-bg-opacity))"
    }
  }, {
    "> :first-child:hover span,& :first-child:focus span": {
      "textDecorationLine": "none"
    }
  }, {
    "> :first-child:focus-within": {
      "borderWidth": "1px",
      "borderStyle": "solid",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(0 0 0 / var(--tw-border-opacity))",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(242 244 237 / var(--tw-bg-opacity))"
    }
  }, handleStyles(numberOfChildren, is400percent)];
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CardContainerStyled,
  ContentLayout,
  IconContainerStyled,
  IconStyled
});
//# sourceMappingURL=CardContainer.styled.js.map